<div class="audit-filter">
  <div class="filter-row">
    <htx-datepicker-field
      [ctrl]="form.get('from')!"
      [label]="'auditLog.filter.from' | transloco"
    ></htx-datepicker-field>

    <htx-datepicker-field
      [ctrl]="form.get('to')!"
      [label]="'auditLog.filter.to' | transloco"
    ></htx-datepicker-field>

    <htx-dropdown-field
      [ctrl]="form.get('action')!"
      [label]="'auditLog.filter.action' | transloco"
      [options]="actionOptions"
    ></htx-dropdown-field>

    <htx-dropdown-field
      [ctrl]="form.get('outcome')!"
      [label]="'auditLog.filter.outcome' | transloco"
      [options]="outcomeOptions"
    ></htx-dropdown-field>

    <htx-text-field
      [ctrl]="form.get('actorIamId')!"
      [label]="'auditLog.filter.actor' | transloco"
      [placeholder]="'auditLog.filter.actorPlaceholder' | transloco"
    ></htx-text-field>

    @if (isDsa) {
      <htx-text-field
        [ctrl]="form.get('organizationId')!"
        [label]="'auditLog.filter.organization' | transloco"
        [placeholder]="'auditLog.filter.organizationPlaceholder' | transloco"
      ></htx-text-field>
    }

    <htx-text-field
      [ctrl]="form.get('q')!"
      [label]="'auditLog.filter.search' | transloco"
    ></htx-text-field>
  </div>

  <div class="filter-actions">
    <htx-button variant="secondary" (click)="apply()">
      {{ 'auditLog.filter.apply' | transloco }}
    </htx-button>
    <htx-button variant="tertiary" (click)="reset()">
      {{ 'auditLog.filter.reset' | transloco }}
    </htx-button>
    <span class="spacer"></span>
    <htx-button variant="secondary" icon="download" (click)="exportCsv.emit()">
      {{ 'auditLog.export' | transloco }}
    </htx-button>
  </div>
</div>
